import { baseURL } from './colors'
import Cookies from 'js-cookie'

export const newAxiosInstance = {
    baseURL:baseURL,
    headers: {
        "Content-type":'application/json',
        "Authorization": `Bearer ${Cookies.get('bearer')}`
      },
}